// The one place the app reloads itself.
//
// `location.reload()` is not spy-able in jsdom (the `Location` object is not configurable there), and a test
// that cannot watch the reload cannot prove the thing BUG-054 is about: that the app reloads ONCE, and then
// stops. So the call lives behind this seam and every caller goes through it.

/** Reload the current document. The only caller in production is the stale-build guard (`staleBuild.ts`). */
export function reloadPage(): void {
  window.location.reload();
}
